import { Platform } from '@/utils/platform';
import { invoke } from '../../QTBridge';

export const closeView = () => {
  if (Platform.isPOPO) {
    console.log('call qt: closeView');
    invoke('closeView').catch((e) => console.error(e));
  }
};
